import React from "react";
import { NavLink } from "react-router-dom";

import "./NavItems.css";

const NavItems = (props) => {
  return (
    <ul className="NavItems">
      <li>
        About
        <div className="DropDownMenu">
          <NavLink to="/our-story">Our Story</NavLink>
          <NavLink to="/our-team">Meet The Pros</NavLink>
          <NavLink to="/sponsors">Sponsors</NavLink>
          <NavLink to="/schedule">Race Schedule</NavLink>
        </div>
      </li>
      <li>
        Performance
        <div className="DropDownMenu">
          <NavLink to="/training/overview">Overview</NavLink>
          <NavLink to="/training/strength">Strength & Conditioning</NavLink>
          <NavLink to="/training/nutrition">Nutrition</NavLink>
          <NavLink to="/training/health">Running Health</NavLink>
          <NavLink to="/training/mindset">Mindset</NavLink>
        </div>
      </li>
      {/* <li>
        <NavLink to="/news">News</NavLink>
      </li> */}
      <li>
        <NavLink to="/dmv-meet">DMV Meet</NavLink>
      </li>
      <li>
        <a href="https://www.districttrackgear.com/">Shop</a>
      </li>
    </ul>
  );
};

export default NavItems;
